import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const DialogLoading = ({ open, handleOpenCadProd }) => {
  return (
    <Dialog open={open} onClose={handleOpenCadProd}>
      <DialogTitle>Carregando...</DialogTitle>
      <DialogContent>
        <CircularProgress />
        <p>Por favor, aguarde enquanto carregamos os dados.</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpenCadProd} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogLoading;
